module.exports = __webpack_public_path__ + "static/media/frontLoadContainer.8dbe0fac.png";